import React from 'react';
import Home from '../components/Home';
import MainLayout from '../layouts/MainLayout';

const HomePage = () => {
    return (
        <MainLayout>
            <Home />
        </MainLayout>
    )
}

export default HomePage